import * as Yup from "yup";
import {defaultAddressValidationSchema} from "../utils/constants/AddressFields";
import {ascii} from "../utils/utils";
import {lengthErrorMsg} from "../utils/constants/YupErrorMessages";

const validationSchema = defaultAddressValidationSchema.concat(
    Yup.object().shape({
        name: ascii.uppercase('Name should be in uppercase').required('Name is required'),
        firm: ascii.uppercase('Firm should be in uppercase').required('Firm is required'),
        membership_number: ascii.length(6, lengthErrorMsg).required('Membership Number is required'),
        registration_number: ascii.length(8, lengthErrorMsg).required('Registration Number is required'),
        email: Yup.string().email('Enter a valid Email ID').required('Email is Required'),
        // Optional, but exactly ten digits when given. The utility wants it - it prints
        // the CA's mobile and derives the country code shown beside it - yet accountants
        // created before 7 Sep 2026 have none, so requiring it would block editing them.
        // excludeEmptyString matters: without it Yup runs the pattern against '' and
        // an accountant with no number becomes unsaveable, which is the opposite of
        // optional.
        mobile: Yup.string().matches(/^\d{10}$/, {
            message: 'Enter a 10 digit mobile number', excludeEmptyString: true,
        }).nullable(),
        // No certification_ip here. The address changes from client to client, so it
        // is typed on each transaction's Details of Accountant step, not stored
        // against the accountant. See cbs/validations.js.

        // The placeholder in UtilityMapping is '-1', not '1', so this guard has never
        // fired. It stayed hidden because the form defaulted to Maharashtra instead
        // of to the placeholder - which is how an Ahmedabad accountant reached a real
        // certificate carrying Maharashtra on 22 Aug 2026.
        state: Yup.string().notOneOf(['-1'], 'Select a value').required('State is required'),
        pan_col: ascii.length(10, lengthErrorMsg).required('Pan Card Number is required'),
        // The API requires a pincode (Address.pincode is not blank=True), but nothing
        // here asked for one, so a blank box was submitted and came back a silent 400.
        pincode: ascii.matches(/^\d{6}$/, 'Pincode should be 6 digits').required('Pincode is required')
    })
);

export default validationSchema;
